import {NgModule} from '@angular/core';
import {SharedModule} from '../../core/shared.module';
import {AkquiseSaveComponent} from './akquise-save.component';
import {UIRouterModule} from '@uirouter/angular';

@NgModule({
    imports: [
        UIRouterModule.forChild(),
        SharedModule,
    ],
    declarations: [AkquiseSaveComponent],
    exports: [AkquiseSaveComponent]
})
export class AkquiseSaveModule {
}
